// Shared message-composer strings (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'composer.mention_hint': 'Mention someone',
  'composer.customer_tag': 'customer',
  'composer.cancel_reply': 'Cancel reply',
  'composer.send_shortcut_hint': 'Send ({keys})',
}

export const zhTW = {
  'composer.mention_hint': '提及某人',
  'composer.customer_tag': '客戶',
  'composer.cancel_reply': '取消回覆',
  'composer.send_shortcut_hint': '傳送（{keys}）',
}
